import React from "react";

import { getMainContent } from "api/main.api";
import { getPredictors } from "api/predictors.api";
import useMainPage from "hooks/main/useMainPage";
import Subscription from "components/forms/Subscription";
import PredictorsContainer from "containers/PredictorsContainer";
import PredictionsContainer from "containers/PredictionsContainer";
import PromisesContainer from "containers/PromisesContainer";
import SurveysContainer from "containers/SurveysContainer";
import HeroSection from "components/head/HeroSection";
import CustomHead from "components/head/CustomHead";

const serializeData = (data) => {
  if (!Array.isArray(data)) return data;

  return data.map((item) => {
    const serializedItem = { ...item };

    Object.entries(serializedItem).forEach(([key, value]) => {
      if (value instanceof Date) {
        serializedItem[key] = value.toISOString();
        return;
      }
      if (
        value &&
        typeof value === "object" &&
        typeof value.seconds === "number"
      ) {
        serializedItem[key] = new Date(value.seconds * 1000).toISOString();
        return;
      }

      if (typeof value === "string" && !Number.isNaN(Date.parse(value))) {
        serializedItem[key] = value;
      }
    });

    return serializedItem;
  });
};

const Main = ({
  predictions,
  promises,
  predictors,
  surveys,
  topPredictors,
}) => {
  const {
    updatedPredictions,
    updatedPromises,
    updatedPredictors,
    updatedSurveys,
  } = useMainPage({
    predictions,
    promises,
    predictors,
    surveys,
  });

  return (
    <>
      <CustomHead
        title="Prognos.am — Կանխատեսումների և Խոստումների Հարթակ"
        description="Միացե՛ք Prognos-ին, հետևե՛ք հանրային կանխատեսումներին ու խոստումներին, մասնակցե՛ք քվեարկություններին և գնահատե՛ք հեղինակների վարկանիշները։"
        poster="/logo.svg"
      />
      <HeroSection bubbles={topPredictors} />
      <div className="flex flex-col gap-6 md:gap-8 items-center w-full max-w-7xl mx-auto px-4 sm:px-6 md:px-8 mt-6 pb-20 md:pb-8 overflow-x-hidden">
        <PredictionsContainer updatedPredictions={updatedPredictions} />
        <PromisesContainer updatedPromises={updatedPromises} />
        <PredictorsContainer updatedPredictors={updatedPredictors} />
        <SurveysContainer updatedSurveys={updatedSurveys} />
        <Subscription />
      </div>
    </>
  );
};

export async function getServerSideProps() {
  const mainContent = await getMainContent();
  const topPredictors = await getPredictors(
    null,
    {
      order: { orderBy: "collectedPoints", direction: "desc" },
    },
    20,
  );

  const formatData = (data) =>
    data.reduce((acc, category) => {
      acc[category.id] = category.content;
      return acc;
    }, {});

  const { predictions, promises, predictors, surveys } =
    formatData(mainContent);

  return {
    props: {
      predictions: serializeData(predictions),
      promises: serializeData(promises),
      predictors: serializeData(predictors),
      surveys: serializeData(surveys),
      topPredictors: topPredictors.predictors.map((predictor) => ({
        id: predictor.id,
        name: `${predictor.firstName} ${predictor.lastName}`,
        image: predictor.image,
        description: predictor.description,
        collectedPoints: predictor.collectedPoints || 0,
      })),
    },
  };
}

export default Main;
